<template>
  <v-dialog v-model="show" :retain-focus="false" persistent max-width="800px" :loading="isLoading">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" md="12" class="d-flex justify-space-between">
            {{ $t("bookings.checkin_params") }}
            <v-btn icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="12" class="mt-0 pt-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-checkbox v-model="bookingData.clean_start" :label="$t('bookings.clean_car')" class="mr-1" hide-details></v-checkbox>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-checkbox v-model="bookingData.gas_start_full" :label="$t('bookings.full_tank')"
                  class="mr-1" hide-details></v-checkbox>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-checkbox v-model="bookingData.technical_check_start"
                  :label="$t('bookings.technical_check')" hide-details></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" md="12" v-if="!bookingData.gas_start_full">
            <v-text-field v-model="bookingData.gas_start" type="text"
              :label="$t('bookings.lost_gas')" hide-details></v-text-field>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field :label="$t('bookings.current_mileage')"
              v-model.number="bookingData.start_mileage" type="number" hide-details></v-text-field>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field v-model="bookingData.other_equipment" type="text"
              :label="$t('bookings.other_equipment')" hide-details></v-text-field>
          </v-col>
          <v-col cols="12" md="12" v-if="!bookingData.technical_check_start">
            <v-text-field v-model="bookingData.technical_check_start_comment" type="text"
              :label="$t('bookings.technical_check_comment')" hide-details></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" text @click="close">{{ $t("custom.close") }}</v-btn>
        <v-btn color="success" @click="checkIn" :loading="isLoading">{{ $t("bookings.checkin_car") }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DepartureDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    booking: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bookingData: {}
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        // Создаем копию объекта booking при открытии диалога
        this.bookingData = JSON.parse(JSON.stringify(this.booking));
      }
    },
    booking: {
      handler(newVal) {
        // Обновляем bookingData при изменении booking для показа корректного пробега начала бронирования
        if (this.show) {
          this.bookingData = JSON.parse(JSON.stringify(newVal));
        }
      },
      deep: true
    }
  },
  methods: {
    close() {
      this.show = false;
    },
    checkIn() {
      this.$emit('check-departure-mileage', this.bookingData.start_mileage, this.bookingData);
    }
  }
}
</script>
